import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// pc
import Home from '../views/Home.vue'
import Nav from '../views/nav.vue'
import MobNav from '../views/mobnav.vue'
// import Videospecial from '@/components/home/videospecial/videospecial.vue'
// import Videospecialdetail from '@/components/home/videospecial/videodetail.vue'
// import VideospecialList from '@/components/home/videospecial/videolist.vue'
import VideoList from '@/components/home/videotype/videolist.vue'
import VideoDetail from '@/components/home/videotype/videodetail.vue'
import Personalcenter from '@/components/personalcenter/personalcenter.vue'
import Personalinfo from '@/components/personalcenter/common/personalinfo.vue'
import ChangePwd from '@/components/personalcenter/common/changepwd.vue'
import Favorite from '@/components/personalcenter/common/favorite.vue'
import ChangeEmail from '@/components/personalcenter/common/changeemail.vue'
import ChangePhone from '@/components/personalcenter/common/changephone.vue'
import Ministrator from '@/components/personalcenter/administrator/administrator.vue'
// import SpecialAdd from '@/components/backgroundMg/special-mg/add.vue'
// import SpecialList from '@/components/backgroundMg/special-mg/mglist.vue'
import Tag from '@/components/backgroundMg/tag-mg/tag.vue'
import TagGourp from '@/components/backgroundMg/tag-mg/tagGroup.vue'
import Login from '@/components/login/login.vue'

import Staff from '@/components/backgroundMg/staff-mg/stafflist.vue'
import StaffAdd from '@/components/backgroundMg/staff-mg/staffadd.vue'
import StaffRecycle from '@/components/backgroundMg/staff-mg/recycle.vue'
import Notice from '@/components/backgroundMg/notice-mg/notice.vue'
import NoticeAdd from '@/components/backgroundMg/notice-mg/noticeadd.vue'
import MessageInfo from '@/components/backgroundMg/message-mg/message.vue'
import MessageAdd from '@/components/backgroundMg/message-mg/messageadd.vue'
import AdvertiseGroup from '@/components/backgroundMg/advertise-mg/AdvertiseGroup.vue'
import AdvertiseDetail from '@/components/backgroundMg/advertise-mg/AdvertiseDetail.vue'
import AdvertiseAddImg from '@/components/backgroundMg/advertise-mg/AdvertiseAddImg.vue'
import TopicType from '@/components/backgroundMg/topicType-mg/topicType.vue'
import Ofline from '@/components/backgroundMg/ofLineVideo-mg/oflineVideoList-mg.vue'
import searchCom from '@/components/backgroundMg/comAndPerson-mg/searchCom.vue'
import searchPerson from '@/components/backgroundMg/comAndPerson-mg/searchPerson.vue'
import Log from '@/components/backgroundMg/log-mg/buslog.vue'
import Analyse from '@/components/backgroundMg/log-mg/analyse.vue'

import SearchPages from '@/components/home/searchpages/searchpages.vue'
import HomeNotice from '@/components/home/notice/notice.vue'
import FlowPage from '@/components/home/searchpages/flowpage.vue'
// mobile
import DoorCategory from '@/components/mobile/searchpage/doorcategory'
import TypeCategory from '@/components/mobile/searchpage/type.vue'
import PersonSearch from '@/components/mobile/searchpage/personser.vue'
import MobileVideoList from '@/components/mobile/videolist.vue'
import MobileVidelDetail from '@/components/mobile/videodetail.vue'
import VideoBox from '@/components/mobile/video.vue'

import MobPersonInfo from '@/components/mobile/personinfo.vue'
import EditPersonInfo from '@/components/mobile/personinfo/editperson.vue'
import MobCollect from '@/components/mobile/personinfo/collect.vue'
import EditMobEmail from '@/components/mobile/personinfo/editemail.vue'
import EditMobPhone from '@/components/mobile/personinfo/editphone.vue'
import EditPwd from '@/components/mobile/personinfo/editpwd.vue'
import HighSearch from '@/components/mobile/search.vue'
import MobileFlowPage from '@/components/mobile/flowpage.vue'

// import MHome from '@/mobile/home.vue'

// 单独引用 message
import { Message } from 'element-ui'
import store from '../vuex/store.js'
Vue.use(Router)

var router = new Router({
  mode: 'hash',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home', // pc端首页
      name: 'home',
      component: Home

    },
    // {
    //   path: 'm_home',
    //   name: 'MHome',
    //   component: MHome
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      path: '/nav',
      name: 'nav',
      component: Nav,
      children: [
        // {
        //   path: '/videospecial',
        //   component: Videospecial,
        //   children: [
        //     {
        //       path: '/videolist',
        //       component: VideospecialList
        //     },
        //     {
        //       path: '/videodetail',
        //       component: Videospecialdetail
        //     }
        //   ]
        // },
        {
          // 个人中心
          path: '/personalcenter',
          name: 'personalcenter',
          component: Personalcenter,
          children: [
            {
              path: '/personalinfo',
              component: Personalinfo
            },
            {
              path: '/changepwd',
              component: ChangePwd
            },
            {
              path: '/favorite',
              component: Favorite
            },
            {
              path: '/changeemail',
              component: ChangeEmail
            },
            {
              path: '/changephone',
              component: ChangePhone
            }

          ]
          // children: [
          //   {
          //     path: '/personalcenter/personalinfo',
          //     name: 'personalinfo',
          //     component: Personalinfo
          //   },
          //   {
          //     path: '/personalcenter/changepwd',
          //     name: 'changepwd',
          //     component: ChangePwd
          //   },
          //   {
          //     path: '/personalcenter/favorite',
          //     name: 'favorite',
          //     component: Favorite
          //   },
          //   {
          //     path: '/personalcenter/changeemail',
          //     name: 'changeemail',
          //     component: ChangeEmail
          //   }

          // ]
        },
        {
          path: '/videolist2',
          component: VideoList
        },
        {
          path: '/videodetail2',
          component: VideoDetail
        },
        {
          path: '/searchpages',
          component: SearchPages
        },
        {
          path: '/flowpage',
          component: FlowPage
        },
        {
          path: '/homenotice',
          component: HomeNotice
        }
        // {
        //   path: '/category1',
        //   component: DoorCategory
        // },
        // {
        //   path: '/category2',
        //   component: TypeCategory
        // },
        // {
        //   path: '/category3',
        //   component: PersonSearch
        // },
        // {
        //   path: '/mobvideolist',
        //   component: MobileVideoList
        // },
        // {
        //   path: '/mobvideodetail',
        //   component: MobileVidelDetail
        // },
        // {
        //   path: '/personinfo',
        //   component: MobPersonInfo
        // },
        // {
        //   path: '/editpersoninfo',
        //   component: EditPersonInfo
        // },
        // {
        //   path: '/mobcoll',
        //   component: MobCollect
        // },
        // {
        //   path: '/editemail',
        //   component: EditMobEmail
        // },
        // {
        //   path: '/editpwd',
        //   component: EditPwd
        // }

      ]
    },
    {
      path: '/mobnav',
      name: 'mobnav',
      component: MobNav,
      children: [
        {
          path: '/category1',
          component: DoorCategory
        },
        {
          path: '/category2',
          component: TypeCategory
        },
        {
          path: '/category3',
          component: PersonSearch
        },
        {
          path: '/video',
          component: VideoBox,
          children: [
            {
              path: '/mobvideolist',
              component: MobileVideoList
            },
            {
              path: '/mobvideodetail',
              component: MobileVidelDetail
            }
          ]
        },
        // {
        //   path: '/mobvideolist',
        //   component: MobileVideoList
        // },
        // {
        //   path: '/mobvideodetail',
        //   component: MobileVidelDetail
        // },
        {
          path: '/personinfo',
          component: MobPersonInfo
        },
        {
          path: '/editpersoninfo',
          component: EditPersonInfo
        },
        {
          path: '/mobcoll',
          component: MobCollect
        },
        {
          path: '/editemail',
          component: EditMobEmail
        },
        {
          path: '/editphone',
          component: EditMobPhone
        },
        {
          path: '/editpwd',
          component: EditPwd
        },
        {
          path: '/highsearch',
          component: HighSearch
        },
        {
          path:'/mobileflowpage',
          component: MobileFlowPage
        }
      ]
    },
    {
      path: '/adminstrator',
      name: 'administrator',
      component: Ministrator,
      children: [
        // {
        //   path: '/specialadd',
        //   component: SpecialAdd
        // },
        // {
        //   path: '/specaillist',
        //   component: SpecialList
        // },
        {
          path: '/tag',
          component: Tag
        },
        {
          path: '/tagGroup',
          component: TagGourp
        },
        {
          path: '/stafflist',
          component: Staff
        },
        {
          path: '/staffadd',
          component: StaffAdd
        },
        {
          path: '/staffrecyle',
          component: StaffRecycle
        },
        {
          path: '/notice',
          component: Notice
        },
        {
          path: '/noticeadd',
          component: NoticeAdd
        },
        {
          path: '/message',
          component: MessageInfo
        },
        {
          path: '/messageadd',
          component: MessageAdd
        },
        {
          path: '/AdvertiseGroup',
          component: AdvertiseGroup
        },
        {
          path: '/AdvertiseDetail',
          component: AdvertiseDetail
        },
        {
          path: '/AdvertiseAddImg',
          component: AdvertiseAddImg
        },
        // {
        //   path: '/topicType',
        //   component: TopicType
        // },
        {
          path: '/Ofline',
          component: Ofline
        },
        {
          path: '/searchCom',
          component: searchCom
        },
        {
          path: '/searchPerson',
          component: searchPerson
        },
        {
          path: '/buslog',
          component: Log
        },
        {
          path: '/Analyse',
          component: Analyse
        }
      ]
    }

  ]
})

// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }
// 添加一个前置导航守卫
//  这句代码会在路由发生改变之前执行，如果不调用 next 方法，后续的代码不会执行
router.beforeEach((to, from, next) => {
  // console.log(to.path)
  // 在判断时，需要将 login 路由排除掉
  if (to.path == '/stafflist' || to.path == '/staffadd' || to.path == '/tag' || to.path == '/tagGroup' || to.path == '/buslog' || to.path == '/Analyse' || to.path == '/noticeadd') {
    // 判断用户是否登录:验证 token
    var token = window.localStorage.getItem('token')
    // console.log(token)
    if (!token) {
      // 提示用户没有登录
      Message.error('您还没有登录，请先登录')
      router.push('/login')
    } else {
      next()
    }
  } else {
    next()
  }
  // 手机端
  if (to.path == '/home') {
    // console.log(store)
    store.state.activeId = 0
    next()
  } else if (to.path == '/personinfo') {
    store.state.activeId = 2
    next()
  } else if (to.path == '/highsearch') {
    store.state.activeId = 1
    next()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js